import { Controller } from "@hotwired/stimulus"

// Thin wrapper around the native <dialog> element — used for the invite
// modal, confirm dialogs, and anything else in README's "Global overlays"
// list. showModal()/close() give us the backdrop and ESC-to-close for free.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
